var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.payload ? _c('div', [_c('NftPayloadView', {
    attrs: {
      "payload": _vm.payloadBase,
      "small": true
    }
  }), _c('div', {
    staticClass: "two_col"
  }, [_c('div', [_c('div', {
    staticClass: "utxo_label"
  }, [_vm._v("Group ID")]), _c('div', [_vm._v(_vm._s(_vm.groupID))])]), _c('div', {
    staticClass: "payload"
  }, [_c('div', {
    staticClass: "utxo_label"
  }, [_vm._v(" " + _vm._s(_vm._f("getType")(_vm.payloadBase.typeID())) + " Payload ")]), _vm.payloadBase.typeID() === 24 ? _c('pre', {
    staticClass: "monospace code"
  }, [_vm._v(_vm._s(JSON.stringify(JSON.parse(_vm.text), null, 2)))]) : _c('div', {
    staticClass: "monospace code"
  }, [_vm._v(_vm._s(_vm.text))])])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }